module.exports = __webpack_public_path__ + "static/media/offices (11).c0f77a24.webp";